import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import { getPcodeDict } from "@/utils/dataStorage";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useQuestionModel } from "../questionModel";


export function PageHeader() {
    const { t } = useTranslation();
    const options = getPcodeDict("038").children.map(item => ({ label: item.title, value: item.title, key: item.dictCode }));
    const searchFields = [
        {
            type: "Input",
            placeholder: t(`paper.view.PageHeader.问题名称`),
            fieldName: "name"
        },
        {
            type: "Select",
            placeholder: t(`paper.view.PageHeader.题库类型`),
            fieldName: "typeName",
            options: options
        }
    ]

    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useQuestionModel();

    return (
        <YhPageHeader
            title= {t(`paper.view.PageHeader.问题题库`)}
            size="small"
            triggerSearch
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}